import Image from 'next/image'
import { ComponentPropsWithoutRef } from 'react'

import { CopyrightText } from '@/components/copyright-text'
import Link from '@/update-monitor/Link'
import { cn } from '@/utils/tw-helpers'

interface Props extends ComponentPropsWithoutRef<'footer'> {}

export const WebFooter = ({ className, ...rest }: Props): JSX.Element => {
  return (
    <footer
      className={cn(
        'mt-auto flex flex-col bg-white px-5 pb-6 pt-5 md:h-[150px] md:flex-row md:px-[18px] md:pb-0 md:pt-0 lg:h-[165px] lg:px-6',
        className
      )}
      {...rest}
    >
      <div className="order-2 mt-[30px] flex flex-col items-center md:order-1 md:mt-11 md:block">
        <Image
          src="/gApp_logo.svg"
          width={196}
          height={52}
          alt="LogiQlabo"
          className="h-[32px] w-[120px] md:h-[40px] md:w-[150px] lg:h-[52px] lg:w-[196px]"
        />
        <p className="ml-[7px] mt-2.5 text-center text-[10px] font-medium text-[#919396] md:mt-[3px] md:text-xs lg:mt-1.5">
          <CopyrightText />
        </p>
      </div>

      <div className="order-1 ml-auto flex w-full flex-col items-center md:order-2 md:w-auto md:flex-row md:items-start">
        <ul className="w-full md:mt-9 md:w-auto lg:mt-10">
          {[
            {
              title: 'プライバシーポリシー',
              href: '/web/privacy-policy',
              isNewTab: true,
            },
            {
              title: 'サービス利用規約',
              href: '/web/terms-of-service',
              isNewTab: true,
            },
            {
              title: 'ウェブサイト利用条件',
              href: 'https://www.sonyged.com/terms-and-conditions',
              isNewTab: true,
            },
          ].map((item, index) => (
            <li key={index}>
              <Link
                href={item.href}
                className="block border-b border-b-outline py-[15px] text-center text-[13px] font-medium text-secondary-text md:border-none md:py-0 md:text-left lg:text-[15px]"
                target={item.isNewTab ? '_blank' : undefined}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
        <ul className="w-full md:ml-[42px] md:mr-[15px] md:mt-9 md:w-auto lg:ml-[85px] lg:mr-6 lg:mt-10">
          {[
            {
              title: '特定商取引法に基づく表示',
              href: 'https://www.sonyged.com/logiq/commerce',
              isNewTab: true,
            },
            {
              title: '運営会社',
              href: 'https://www.sonyged.com/about',
              isNewTab: true,
            },
            {
              title: 'お問い合わせ',
              href: 'https://support.sonyged.com/hc/ja/requests/new',
              isNewTab: true,
            },
          ].map((item, index) => (
            <li key={index}>
              <Link
                href={item.href}
                className="block border-b border-b-outline py-[15px] text-center text-[13px] font-medium text-secondary-text md:border-none md:py-0 md:text-left lg:text-[15px]"
                target={item.isNewTab ? '_blank' : undefined}
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  )
}
